export class InvalidJsonError extends Error {
	constructor(paramName: string, cause: Error) {
		super(`${paramName} parameter is invalid: ${cause.message}`)
		this.name = this.constructor.name
		if (cause) {
			this.stack = `${this.stack}\nCaused By: ${cause.stack}`
		}
	}
}
